import { z } from "zod/v4";

import {
  LiveRunsLogLevelList,
  LiveRunsLogLevelSchema,
} from "../../agentic-codegen/live-runs";

import { AgenticLogicRuleLogEntryDescriptions } from "../../../descriptions/agentic-logic.describe";
import { assertDescriptions } from "../../../descriptions/types";

// ---------------------------------------------------------------------------
// Rule runtime logger entries (marker-logger protocol payload)
// ---------------------------------------------------------------------------

// The shared live-runs log vocabulary; a rule entry adds only the invocation.
export const AgenticLogicRuleLogLevelList = LiveRunsLogLevelList;
export const AgenticLogicRuleLogLevelSchema = LiveRunsLogLevelSchema;

export type AgenticLogicRuleLogLevel =
  (typeof AgenticLogicRuleLogLevelList)[number];

export const AgenticLogicRuleLogEntrySchema = z
  .object({
    level: AgenticLogicRuleLogLevelSchema.describe(
      AgenticLogicRuleLogEntryDescriptions.level
    ),
    message: z.string().describe(AgenticLogicRuleLogEntryDescriptions.message),
    details: z
      .unknown()
      .optional()
      .describe(AgenticLogicRuleLogEntryDescriptions.details),
    invocationId: z
      .uuid()
      .optional()
      .describe(AgenticLogicRuleLogEntryDescriptions.invocationId),
    timestamp: z.iso
      .datetime()
      .describe(AgenticLogicRuleLogEntryDescriptions.timestamp),
  })
  .describe(AgenticLogicRuleLogEntryDescriptions._schema);

export type AgenticLogicRuleLogEntry = z.infer<
  typeof AgenticLogicRuleLogEntrySchema
>;

assertDescriptions<
  typeof AgenticLogicRuleLogEntryDescriptions,
  AgenticLogicRuleLogEntry
>();
